export default class SupportRequest {
  constructor() {
    this.Type = 0
    this.Subject = null
    this.ShopId = 0
    this.CategoryId = 0
    this.Description = ''
  }
}
